import { Typography } from "@mui/material";
import { type VariantType } from "notistack";

export type KnownFixDetails = {
  title: string;
  fixContent: React.ReactNode;
  snackbarVariant?: VariantType;
};

export const KNOWN_ERROR_FIXES = {
  "session.metadata.discount_code": {
    title:
      "Test sends and previews will not work properly until you have migrated to Coupon Codes",
    snackbarVariant: "warning",
    fixContent: (
      <Typography>
        This error happens when the discount code is using the{" "}
        <code>session.metadata.discount_code</code> merge tag. To fix this, go
        to Coupon Codes, create a code, and use the Offer Block instead of the
        merge tag.
      </Typography>
    ),
  },
  "|cut:": {
    title: "Merge tags using the 'cut' filter need an updated format",
    snackbarVariant: "warning",
    fixContent: (
      <Typography>
        This error happens when using an outdated merge tag filter format.
        Please change this format:{" "}
        <pre>${`{{ tile_data.return_url|cut:'https://example.com' }}`}</pre>
        to this format:{" "}
        <pre>
          ${`{{ tile_data.return_url | replace('https://example.com', '') }}`}
        </pre>
      </Typography>
    ),
  },
} satisfies Record<string, KnownFixDetails>;

export type KnownErrorMatch = keyof typeof KNOWN_ERROR_FIXES;
